import React from "react";
import { Box } from "@mui/material";

const TemplateFilters = ({ selectedFilterFolder, setSelectedFilterFolder, setCurrentPage }) => {
    const array = [
        { label: "All Types", value: "All" },
        { label: "Single Family", value: "SingleFamily" },
        { label: "Condo", value: "Condo/Townhome" },
        { label: "Land", value: "Land" },
        // { label: "Common", value: "Common" },
        { label: "Multi Family", value: "Multifamily" },
    ];

    return (
        <Box
            className="tw-w-full tw-px-3 tw-flex tw-justify-start sm:tw-justify-center tw-items-center tw-flex-wrap tw-gap-2"
            sx={{
                mb: 1,
                padding: "8px",
                backgroundColor: "#fff",
                border: "0.83px solid #E0DEF7",
                borderRadius: "5px",
                minHeight: "45px",
            }}
        >
            {array.map((item, index) => (
                <Box
                    key={index}
                    onClick={() => {
                        setCurrentPage(1);
                        setSelectedFilterFolder(item.value);
                    }}
                    className={`${selectedFilterFolder === item.value ? "active" : ""} ${selectedFilterFolder === item.value ? "tw-border-[1px] tw-border-primary tw-bg-primary" : "tw-bg-transparent"}`}
                    sx={{
                        cursor: "pointer",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: { xs: "11px", sm: "12px", md: "13px" },
                        display: "flex",
                        fontWeight: "400",
                        color: selectedFilterFolder === item.value ? "#FFFFFF" : "black",
                        paddingX: { xs: "8px", sm: "10px" },
                        paddingY: "6px",
                        textWrap: "nowrap",
                        borderRadius: "5px",
                        minHeight: "30px",
                        boxShadow: selectedFilterFolder === item.value ? "0px 1.65px 22.06px rgba(14, 8, 84, 0.05)" : null,
                        "&:hover": selectedFilterFolder === item.value ? {} : { backgroundColor: "#e0e0e0" },
                    }}
                >
                    {item.label}
                </Box>
            ))}
        </Box>
    );
};

export default TemplateFilters;
